// The QR code generator (/qr-generator), rewritten 25 October 2026: website, Wi-Fi, vCard, email and phone codes with
// colors, a frame with text and a logo, drawn in the browser with bwip-js (no server, no reCAPTCHA). It mounts over
// the copy of itself the page carries (the hero widget), which has the same markup and sizes.
import { createApp } from 'vue';
import App from './App.vue';

const el = document.getElementById('qrGeneratorApp');
if (el) createApp(App).mount(el);
